(function () {
  const initSwiper = (container) => {
    if (!container || container.swiper || typeof Swiper === "undefined") return;

    new Swiper(container, {
      slidesPerView: "auto",
      spaceBetween: 23,
      direction: "horizontal",
      mousewheel: {
        forceToAxis: true
      },
      breakpoints: {
        0: { spaceBetween: 23 },
        750: { spaceBetween: 8 },
        990: { spaceBetween: 8 },
        1440: { spaceBetween: 16 }
      }
    });
  };

  const initAllSections = () => {
    const sections = document.querySelectorAll(".index_single_collection_slider");

    if (!("IntersectionObserver" in window)) {
      sections.forEach((section) => initSwiper(section.querySelector(".single-collection-slider__track")));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          initSwiper(entry.target.querySelector(".single-collection-slider__track"));
          currentObserver.unobserve(entry.target);
        });
      },
      {
        rootMargin: "300px 0px",
        threshold: 0.01
      }
    );

    sections.forEach((section) => observer.observe(section));
  };

  const updateVisibleSwipers = () => {
    document.querySelectorAll(".single-collection-slider__track").forEach((track) => {
      if (track.swiper) {
        track.swiper.update();
      }
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllSections);
  } else {
    initAllSections();
  }

  window.addEventListener("resize", updateVisibleSwipers);
  document.addEventListener("shopify:section:load", initAllSections);
})();